import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import appReducers from 'ducks';

const store = createStore(
    appReducers,
    {},
    applyMiddleware(thunk)
);

export default store;
